import React, { useState, useEffect } from 'react';
import OrdenTrabajoInsumoEditor from './OrdenTrabajoInsumoEditor';
import { connect } from 'react-redux';
import {
  getAllByParent,
  setPending,
  deleted,
} from '../redux/actions/ordenTrabajoInsumoActions';

import { get as getParent } from '../redux/actions/actividadActions';
import { callStatus } from '../utils/constants';
import { setBreadcrumbTitle } from '../redux/actions/uiActions';
import { Button, Space, Modal, Layout } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  EditFilled,
  DeleteFilled,
  PlusCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import MetaTable from './base/MetaTable';
import StateIcon from './base/StateIcon';
import CustomCellRender from './base/CustomCellRender';

const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;
const OrdenTrabajoInsumoList = ({
  location,
  stateData,
  parent,
  insumo,
  inversor,
  dispatch,
  match: {
    params: { id, id2, id3 },
  },
  ordenTrabajoEstado,
}) => {
  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);

  useEffect(() => {
    dispatch(getAllByParent(id3));
    dispatch(getParent(id2));

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (parent.object.status === callStatus.OBJECT_SUCCESS) {
      dispatch(
        setBreadcrumbTitle(
          `/campanas/${id}/actividades/${id2}`,
          `${parent.object.data.establecimiento.nombre} / ${parent.object.data.cultivo.nombre}`
        )
      );
    }
  }, [parent.object.status, parent.object.data, dispatch, id, id2]);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 60,
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Estado',
      dataIndex: 'estado',
      onFilter: (value, record) => {
        return record.estado_id === value;
      },
      sorter: (a, b) => a.estado?.nombre?.localeCompare(b.estado?.nombre),
      filterMultiple: true,
      filters: ordenTrabajoEstado.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
      render: (text) => (
        <>
          <StateIcon value={text?.nombre} />
          <span> {text?.nombre} </span>
        </>
      ),
    },
    {
      ellipsis: true,
      title: 'Insumo',
      dataIndex: 'insumo',
      render: (text, record) => record.insumo?.nombre,
      onFilter: (value, record) => {
        return record.cultivo_id === value;
      },
      sorter: (a, b) => a.insumo?.nombre?.localeCompare(b.insumo?.nombre),
      filterMultiple: true,
      filters: insumo.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },

    {
      width: 100,
      ellipsis: true,
      title: 'Dosis',
      dataIndex: 'dosis',
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Superficie (Ha)',
      dataIndex: 'superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Total Insumo (kg/Ltr)',
      dataIndex: 'total',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Precio unitario U$D',
      dataIndex: 'precio_unitario',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Importe U$D',
      dataIndex: 'importe',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      title: 'Aportante',
      dataIndex: 'inversor',
      render: (text, record) => record.inversor?.nombre,
      onFilter: (value, record) => {
        return record.inversor_id === value;
      },
      sorter: (a, b) => a.inversor?.nombre?.localeCompare(b.inversor?.nombre),
      filterMultiple: true,
      filters: inversor.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
  ];
  return (
    <Layout style={{ height: '100%' }}>
      <Header></Header>
      <Content>
        <MetaTable
          dataSource={stateData.list.data}
          dataColumns={columns}
          bordered={false}
          selection={false}
          loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
        />
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar Insumo
            </Button>
          </ActionsContainer>
        </FooterContainer>{' '}
      </Footer>
      {showEdit ? (
        <OrdenTrabajoInsumoEditor
          id={rowEdit.id}
          parentId={id3}
          actividadId={id2}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const {
    ordenTrabajoInsumo,
    insumo,
    inversor,
    ordenTrabajoEstado,
    actividad,
  } = state;
  const stateData = ordenTrabajoInsumo;
  const parent = actividad;
  return {
    stateData,
    actividad,
    insumo,
    inversor,
    ordenTrabajoEstado,
    parent,
  };
};
export default connect(mapStateToProps)(withRouter(OrdenTrabajoInsumoList));
